import { ComparisonTable } from './comparison-table';

export const ComparisonTableSlice = () => {
  return <ComparisonTable />;
};
